export default __webpack_public_path__ + "static/media/sukukForCategories.16f99baf.jpg";